export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Column - Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/f974ae4a89bf06aece5244b03610bc1c/f7c577313bfcb7ca52808252e916ab4a.png"
                alt="Our Team"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Accent Border */}
            <div className="absolute -bottom-6 -right-6 w-full h-full border-4 border-brand rounded-2xl -z-10"></div>
          </div>

          {/* Right Column - Content */}
          <div>
            <div className="mb-4">
              <span className="text-brand text-sm font-semibold uppercase tracking-wider">
                About All Phases Builders
              </span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Building Excellence Since 2010
            </h2>
            <div className="space-y-4 text-gray-600 leading-relaxed">
              <p>
                All Phases Builders LLC is a premier construction and remodeling company dedicated to delivering exceptional craftsmanship and unparalleled customer service. With over two decades of experience, we have built our reputation on quality, reliability, and integrity.
              </p>
              <p>
                Our team of skilled professionals brings expertise across all phases of construction, from initial design to final completion. We take pride in our attention to detail, commitment to timelines, and ability to transform our clients' visions into reality.
              </p>
              <p>
                Whether you're planning a residential renovation, commercial build-out, or new construction project, we approach every job with the same level of dedication and professionalism. Our goal is not just to meet expectations, but to exceed them at every turn.
              </p>
            </div>

            {/* Key Points */}
            <div className="mt-10 grid grid-cols-2 gap-6">
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-checkbox-circle-fill text-2xl text-brand"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Licensed & Insured</h3>
                  <p className="text-sm text-gray-600">Fully certified and protected</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-checkbox-circle-fill text-2xl text-brand"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Expert Team</h3>
                  <p className="text-sm text-gray-600">Skilled craftsmen</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-checkbox-circle-fill text-2xl text-brand"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Quality Materials</h3>
                  <p className="text-sm text-gray-600">Premium grade products</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-checkbox-circle-fill text-2xl text-brand"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">On-Time Delivery</h3>
                  <p className="text-sm text-gray-600">Reliable scheduling</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
